import functions from './functions.js';
import Slider from "./Slider";
import calendar from  './calendar.js';

$(() => {
    details.init();
})

const details = {
    isMultiUnit: null,
    $form: null,
    form: null,
    params: {
        objectId : null,
        unitId: null, 
        guests: '1,0', 
        dates: null,
        dateFrom: null, 
        dateTo: null, 
        objectGroupId: null,
        partnerId: null
    },
    init() {

        if(! $('.motorrents-details')[0]) {
            return;
        }

        let detailsSlider = [];
        $('#details-slider').each((i, elem) => {
            detailsSlider[i] = new Slider('#' + $(elem).attr('id'), {
                rubberband: false,
                loop: true,
                arrows: true,
                slidesPerView: 2,
                spacing: 8,
                breakpoints: {
                    '(max-width: 1000px)': {
                        slidesPerView: 1,
                    },
                },
            });
        });
        
        // details.calcErrorMessages = JSON.parse($('#details-reservation').attr('data-calcErrorMessages') || '') ;
        details.isMultiUnit = $('#details-reservation').attr('data-ismultiunit');

        details.$form = $('.units-form');
        details.form = details.$form[0];
        if(! details.form) return;

        details.getParams();
        if(details.params.unitId) {
            functions.scrollToElement($('#card-unit-' + details.params.unitId), 100);
            $('#details-unit-' + details.params.unitId).collapse('show');
        }

        if(! details.isMultiUnit) {
            // details.params.dates = details.params.dateFrom + ':' + details.params.dateTo;
        }

        if (details.$form.attr('data-onchange'))
        {
            $('[name="dateTo"]').on('change', e => {
                e.preventDefault();
                // const $target = $(e.target);
                let formData = functions.getFormData(details.$form);
                if (formData.dateFrom && formData.dateTo) 
                {
                    functions.setUrlData(formData, true);
                }
            });
        }
        else
        {
            details.$form.on('submit', e => {
                e.preventDefault();
                let formData = functions.getFormData(details.$form);
                functions.setUrlData(formData, true);
            });
        }

        details.inquiryInit();

        details.params.objectId = details.$form.attr('data-objectid');
        details.params.objectGroupId = details.$form.attr('data-objectgroupid');
        details.params.partnerId = details.$form.attr('data-partnerid');
        let params2 = functions.getUrlData();
        if (params2.unitId) 
        {
            details.params.unitId = params2.unitId;
            delete details.params.objectId;        
        }

        functions.setFormData(details.form, details.params);
        details.getCalculation();


        $(window).on('hashchange', e => {
            details.getParams();
            details.getCalculation();
        });

        
    },
    calendarInit() {
        let config = JSON.parse($('[data-calendarconfig]').attr('data-calendarconfig'));

        calendar.calendar.init(
            $('.datepicker-range-book[name="dates"]'),
            {
                availabilityMask : config.availabilityMask,
                periods : config.periods,
                translations : config.translations,
                containerClass : 'details-booking-calendar'
            },
            details.getCalculation
        );
    },
    inquiryInit() {
        $('form#inquiry').on('submit', e => {
            e.preventDefault();
            $('.contact-btn').addClass('d-none');
            $('.contact-spinner').removeClass('d-none');
            $('.contact-spinner').addClass('d-flex');

            let params = {};
            $.each($(e.currentTarget).serializeArray(), function (i, field) {
                params[field.name] = field.value;
            });

            params['language'] = functions.getLang();

            params['requestId'] = Math.floor(Math.random() * ((9999999 - 1000000) + 1) + 1000000);
            grecaptcha.ready(function () {
                grecaptcha.execute('6LfJlZ4aAAAAADl4CnLjJTsO1UNDl1wXt_dloYxa', { action: 'contact' }).then(function (token) {
                    params['gRecaptchaToken'] = token;
                    params = functions.getDataForUrl(params);
                    $.post('/services/inquiry/', params).then(response => {

                        let $formBody = $(".default");
                        response = JSON.parse(response),
                        response.status ? $('.request-success').removeClass('d-none') : $('.request-error').removeClass('d-none');
                        $formBody.addClass('d-none');

                        setTimeout(() => {
                            $(".request-error, .request-success").addClass('d-none');
                            $formBody.removeClass('d-none');
                            $('.contact-btn').removeClass('d-none');
                            $('.contact-spinner').removeClass('d-flex');
                            $('.contact-spinner').addClass('d-none');
                            $('[data-bs-dismiss="modal"]').click();
                            if (response.status == true) {
                                e.currentTarget.reset();
                            }
                        }, 4000);

                        
                    });
                });
            });
        });
    },
    calendarClear() {
        $('.datepicker-range-book[name="dates"]').flatpickr().clear();
        details.params.dates = null;
        $('.unit-dates').text('--');
        $('.unit-price-total').text('--');
    },
    splitCalendarDates(dates) {
        if(dates || dates == '') {
            const aDates = dates.split(':');
            details.params.dateFrom = aDates[0] ? aDates[0] : null;
            details.params.dateTo = aDates[1] ? aDates[1] : null;
        }
    },
    getParams() {
        details.params = $.extend({}, details.params, functions.getUrlData(true));
        let params2 = functions.getUrlData();
        if (params2.unitId) 
        {
            details.params.unitId = params2.unitId;
            delete details.params.objectId;
        }
        details.splitCalendarDates(details.params.dates);
    },
    isBookable(data) {
        return data.isAvailable && data.calc.total && data.calc.status == 'Active';
    },
    getCalcErrorMessage(error) {
        if (error && details.calcErrorMessages[error.type]) {
            return details.calcErrorMessages[error.type].replace('{$condition}', error.condition);
        }
        return details.calcErrorMessages.general;
    },
    getCalculation(unitId = null) {
        if(
            (details.params.unitId || details.params.objectId) 
            && details.params.guests 
            && details.params.dateFrom 
            && details.params.dateTo 
            && details.params.objectGroupId
        ) {

            return $.getJSON(
                location.protocol
                + '//'
                + location.hostname
                + '/services/calc/'
                + (details.params.unitId ? '?unitId=' + details.params.unitId : '?objectId=' + details.params.objectId)
                + '&guests=' + details.params.guests
                + '&dateFrom=' + details.params.dateFrom
                + '&dateTo=' + details.params.dateTo
                + '&objectGroupId=' + details.params.objectGroupId
                + '&language=' + functions.getLang()
                + '&partnerId=' + details.params.partnerId
            )
            .done(response => {

                if(response.status) {
                    const data = response.data || [];

                    Object.entries(data).forEach(unit => {
                        const unitId = unit[0];
                        const unitData = unit[1];
                        const unitCalc = unitData.calc;

                        const $unit = $('.unit-card[data-unitid=' + unitId + ']');

                        const $btnBooking = $unit.find('.book-btn');

                        if ( $unit && (details.isBookable(unitData)) )
                        {
                            const total = functions.formatMoney(unitCalc.total, 0, '.', ',')  + ' ' + unitCalc.currencySymbol;

                            $unit.find('.from-text').addClass('d-none');
                            $unit.find('.total-text').removeClass('d-none');

                            $unit.find('.price-init').addClass('d-none');
                            $unit.find('.total').removeClass('d-none').text(total);
                            $unit.find('.payment-type').addClass('d-none');

                            $unit.find('.price-old-init').addClass('d-none');
                            $unit.find('.on-request-text').addClass('d-none');

                            $unit.find(".converted-price-init").addClass('d-none');
                            $unit.find(".converted-price").removeClass('d-none').text(functions.formatMoney(unitCalc.totalEUR, 0, '.', ',') + ' kn');

                            $unit.find('.btn-enquiry').addClass('d-none');
                            
                            if ($unit.attr('href'))
                            {
                                $unit.attr('href',
                                    $unit.attr('href').split('?')[0] +
                                    '?unitId=' + unitId +
                                    '#dateFrom=' + details.params.dateFrom +
                                    '&dateTo=' + details.params.dateTo +
                                    '&guests=' + details.params.guests
                                );
                            }


                            if($btnBooking.length) 
                            {
                                $btnBooking.removeClass('disabled d-none');
                                $btnBooking.attr('href',
                                    $btnBooking.attr('href').split('?')[0] +
                                    '?unitId=' + unitId +
                                    '&dateFrom=' + details.params.dateFrom +
                                    '&dateTo=' + details.params.dateTo +
                                    '&partnerId=' + details.params.partnerId +
                                    '&guests=' + details.params.guests
                                );
                            }

                            
                        }
                        else
                        {
                            if ($unit.attr('href'))
                            {
                                $unit.attr('href',
                                    $unit.attr('href').split('?')[0] +
                                    '?unitId=' + unitId +
                                    '#dateFrom=' + details.params.dateFrom +
                                    '&dateTo=' + details.params.dateTo +
                                    '&guests=' + details.params.guests
                                );
                            }
                            if($btnBooking.length) 
                            {
                                $btnBooking.addClass('disabled d-none');
                            }

                            $unit.find('.btn-enquiry').removeClass('d-none');

                            $unit.find(".converted-price-init").addClass('d-none');
                            $unit.find(".converted-price").addClass('d-none');

                            $unit.find('.from-text').addClass('d-none');
                            $unit.find('.total-text').addClass('d-none');

                            $unit.find('.price-init').addClass('d-none');
                            $unit.find('.total').addClass('d-none');
                            $unit.find('.payment-type').addClass('d-none');

                            $unit.find('.price-old-init').addClass('d-none');
                            $unit.find('.on-request-text').removeClass('d-none');
                        }

                        // $('.unit-price-total').each(function (index, item) {
                        //     if(details.isBookable(unitData)) {
                        //         const unitCalc = unitData.calc;
                        //         const total = functions.formatMoney(unitCalc.total, 0, '.', ',')  + ' ' + unitCalc.currencySymbol;
                        //         $inqueryBooking.addClass('d-none');
                        //         $btnBooking.removeClass('disabled');
                        //         $btnBooking.find('[data-book]').toggleClass('d-none', unitData.booking.status != 'Reservation');
                        //         $btnBooking.find('[data-inquiry]').toggleClass('d-none', unitData.booking.status == 'Reservation');
                        //         $('.unit-price-total[data-unitid=' + unitId + ']').text(total);
                        //         $('.unit-price-total[data-unitid=' + unitId + ']').removeClass('d-none');
                        //         $('.unit-total-price[data-unitid=' + unitId + ']').removeClass('d-none');
                        //         $('.unit-price-from[data-unitid=' + unitId + ']').addClass('d-none');
                        //         $('.unit-price-night[data-unitid=' + unitId + ']').addClass('d-none');
                        //         $('.unit-price-container[data-unitid=' + unitId + ']').removeClass('d-none');
                        //         $('.unit-error-container[data-unitid=' + unitId + ']').addClass('d-none');

                        //         $('.unit-dates[data-unitid=' + unitId + ']').text(functions.formatDate(details.params.dateFrom, 'dd.mm.yyyy.') + ' - ' + functions.formatDate(details.params.dateTo, 'dd.mm.yyyy.'));

                        //         $('.dual-price[data-unitid=' + unitId + ']').removeClass('d-none');
                        //         $('.dual-price[data-unitid=' + unitId + ']').find(".unit-price-total-converted").text(functions.formatMoney(unitCalc.totalEUR, 0, '.', ','));

                        //         if($btnBooking.attr('href')) {
                        //             $btnBooking.attr('href',
                        //                 $btnBooking.attr('href').split('?')[0] +
                        //                 '?unitId=' + unitId +
                        //                 '&dateFrom=' + details.params.dateFrom +
                        //                 '&dateTo=' + details.params.dateTo +
                        //                 '&guests=' + details.params.guests
                        //             );
                        //         }
                        //     } else {
                        //         $btnBooking.addClass('d-none');
                        //         $inqueryBooking.removeClass('d-none');

                        //         $('.unit-error-container[data-unitid=' + unitId + ']').removeClass('d-none').html(details.getCalcErrorMessage(unitData.calc.message));
                        //         $('.unit-price-container[data-unitid=' + unitId + ']').addClass('d-none');
                        //         $('.unit-price-total[data-unitid=' + unitId + ']').addClass('d-none');
                        //         $('.unit-total-price[data-unitid=' + unitId + ']').addClass('d-none');
                        //         $('.unit-price-from[data-unitid=' + unitId + ']').addClass('d-none');
                        //         $('.unit-price-night[data-unitid=' + unitId + ']').addClass('d-none');
                        //         $('.dual-price[data-unitid=' + unitId + ']').addClass('d-none');
                        //     }
                        // });

                    });
                }

            }).fail(function (error) {
                console.log(error);
            });
        }

        else {
            $('.btn-booking').addClass('disabled');
        }
    }
};